import View from './View'
/**
 * class Footer
 */
class Footer extends View {
  /**
   * constructor
   */
  constructor (el) {
    super(el)
    this.buttonSound = el.querySelector('.footer__sound')
  }

  showHandler (resolve) {
    resolve()
  }

  hideHandler (resolve) {
    resolve()
  }
}
export default Footer


// WEBPACK FOOTER //
// ./src/scripts/Footer.js